import { Component, Output, output } from '@angular/core';

@Component({
	selector: 'app-form-link',
	standalone: true,
	imports: [],
	templateUrl: './form-link.component.html',
	styleUrl: './form-link.component.scss',
})
export class FormLinkComponent {}
